import React from 'react';
import BaseIcon from './BaseIcon';

import { ReactComponent as IconPath } from 'assets/images/icons/pay.svg';

function PayIcon(props) {
  return <BaseIcon SVGElement={IconPath} {...props} />;
}

export default PayIcon;
